// ABOUTME: Answering a team member's post from a chat. When the newest message is a member's
// post on a brief that waits for the owner (its plan or question), the composer replies to that
// member: the chip says so and the owner's words go to the member as a revision of its brief
// (POST /production-briefs/{id}/answer), with no Marketing run. Removing the chip sends the
// next message the usual way. Shared by Marketing's thread and the member's own chat.
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { answerBrief, getProductionBrief, PRODUCTION_BRIEFS_KEY } from '@/api/productionBriefs'

export interface MemberPost {
  /** The stored message id of the member's post. */
  messageId: string
  briefId: string
  name: string
}

export function useMemberReply(latest: MemberPost | null) {
  const [dismissed, setDismissed] = useState<string | null>(null)
  const candidate = latest && latest.messageId !== dismissed ? latest : null
  // The brief card reads the same query, which the event stream keeps current.
  const brief = useQuery({
    queryKey: [PRODUCTION_BRIEFS_KEY, candidate?.briefId],
    queryFn: () => getProductionBrief(candidate!.briefId),
    enabled: candidate !== null,
  })
  const target = candidate && brief.data?.state === 'waiting' ? candidate : null
  return {
    target,
    dismiss: () => target && setDismissed(target.messageId),
    send: (text: string, clientMessageId: string) =>
      answerBrief(target!.briefId, text, clientMessageId),
  }
}
